export default {
    namespaced: true,
    state: {
        loader: {
            show: false,
            text: null,
        }
    },
    getters: {
        getLoader: (state) => state.loader,
    },
    mutations: {
        SET_LOADER(state, payload) {
            // if set text, then show loader
            // show / hide - boolean - loader without text
            if (typeof payload == "boolean") {
                state.loader = {
                    text: null,
                    show: payload
                }
            } else {
                // only show - text - load with text
                state.loader = {
                    text: payload,
                    show: true
                }
            }
        },
    },
}
